var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-container',[_c('template',{slot:"header"},[_vm._v("\n    Waveforms\n  ")]),_c('template',{slot:"body"},[_c('WaveformsContainer')],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }